// extracted by mini-css-extract-plugin
export default {"container":"ResourceTable-module_container__kDzQ1l"};